import React,{ useRef, useState} from "react";
import { useAppSelector } from "../../../app/hooks";
import clsx from 'clsx';
import ReactJSONEditor from "react-jsoneditor-wrapper";



export const ViewDetails = (props:any) =>{

    const {t} = props;
    const [tab, setTab] = useState('Description');
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const {RequestBody,RequestURI,SystemWebHookSourceName,ActionDescription} = useAppSelector((state) => state.apiRecordLog);

    const JsonParseCheck = () => {
        let parsedJson;
        let isJsonValid = false;
      
        try {
          parsedJson = JSON.parse(ActionDescription);
          isJsonValid = true;
        } catch (error) {
        }
        
        return isJsonValid;
    };
    const handleCloseOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    return (
        <>
            <div className='card-body'>
                <div className='row'>
                    <div className="col-md-10" style={{ marginLeft: '30px', marginTop: '5px' }}>
                        <label className="form-label">{t(`Request URI`)}</label> &nbsp;
                        <div style={{ display: 'inline-block', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                            {RequestURI}
                        </div>
                    </div>
                </div>
                <div className='row' >
                    <div className='card card-custom'>
                        <div className='card-header card-header-stretch overflow-auto'>
                            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Description' })}
                                        onClick={() => setTab('Description')}
                                        role='tab'
                                    >
                                        {t('Description')}
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Request JSON' })}
                                        onClick={() => setTab('Request JSON')}
                                        role='tab'
                                    >
                                        {t('Request JSON')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <form className='form'>
                            <div className='card-body'>
                                <div className='tab-content pt-0'>
                                    <div className={clsx('tab-pane', { active: tab === 'Description' })}>
                                        <div className="row">
                                            {SystemWebHookSourceName}
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                {JsonParseCheck() ? (
                                                    <ReactJSONEditor json={JSON.parse(ActionDescription)} name="Description" mode="view" />
                                                ) : null}
                                                {!JsonParseCheck() ? (
                                                    <div>{ActionDescription}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={clsx('tab-pane', { active: tab === 'Request JSON' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <ReactJSONEditor json={RequestBody} name="RequestBody" mode="view" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                        </button>
                        <button
                            className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                            type='button'


                            data-kt-element='send'
                            onClick={handleCloseOnClickEvent}

                        >
                            {t('Cancel')} 
                        </button>
                    </div>
                </div>
            </div>

        </>
    )
   
}
